var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`game-wrapper ${_vm.gameOrientation}`},[_c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner"},[(_vm.downloaded)?_c('div',{attrs:{"id":"game-container"}}):_c('div',{staticClass:"placeholder"},[_vm._v(" Downloading ... ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }